import React, { useState,useEffect } from 'react';
import { Button, ButtonGroup, Card, CardBody, Row, Col, Label, Input } from 'reactstrap';
import ErrorBoundary from "components/ErrorBoundary";
import useAxios from 'hooks/useAxios';
import { onExport, getUpdatedFilter } from 'utils/helper';
import UnitsReplenishedTable from './UnitsReplenishedTable';

let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    order: '',
    filters: [],
  };
  
  let thirdPartyAdminDetails = {};
  
  let filtervalues = {}
  
  const UnitsReplenished = ({ tenantID, rowData }) => {
  
    const API = useAxios();
    const [state, updateState] = useState({
      data: [],
      coveredEntity: [],
      loading: false,
      selectedEntity: '',
      coveredId: '',
      records: 0,
      reset: false,
    });
    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  
  
    useEffect(() => {
      initialFilters = {
        currentPage: 1,
        pageSize: 10,
        orderBy: '',
        order: '',
        filters: [],
      };
      setState({ data: [], records: 0 });
      if (rowData) {
        const { ndc, contractId, opaCode, npi } = rowData;
        if (ndc) {
          initialFilters.filters = getUpdatedFilter(
            'DrugID',
            ndc,
            initialFilters
          );
        }
        initialFilters.currentPage = 1;
        fetchUnitsReplenishedData(initialFilters);
      }
  
    }, []);
  
    const fetchUnitsReplenishedData = async (pageDetails = {}, hasColumnFilter) => {
      setState({ loading: true });
      let filter = { ...pageDetails };
      if (hasColumnFilter) {
        filter.filters = [...initialFilters.filters, ...pageDetails.filters];
        //initialFilters.filters = [...filter.filters];
      } else {
        initialFilters = { ...initialFilters, ...filter };
      }
      try {
        const { data } = await API.post(
          `/${tenantID}/Inventory/UnitsReplenished/${rowData.contractID}`, filter
        );
        if (data) {
          setState({
            data: data.items,
            records: data.totalRecords,
            loading: false,
          });
        } else {
          setState({
            data: [],
            records: 0,
            loading: false,
          });
        }
      } catch (error) {
        setState({ loading: false, data: [], records: 0 });
      }
    };
  
    const handleExport = () => {
      const { access_token } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
      const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Inventory/ExportUnitsReplenished/${rowData.contractID}?access_token=${access_token}`;
      onExport(action, initialFilters);
    };
  
    const onPageChange = (filter, hasFilter) => {
      if (hasFilter) {
        fetchUnitsReplenishedData(filter, true);
      } else {
        fetchUnitsReplenishedData(filter);
      }
    };
  
    const handleSearchColumnFilters = async (columnFilters) => {
      await fetchUnitsReplenishedData({ ...initialFilters, ...columnFilters }, true);
    };
  
    const refetch = (hasReset) => {
      if (hasReset) {
        initialFilters = {
          ...initialFilters,
          currentPage: 1,
        };
      }
      fetchUnitsReplenishedData(initialFilters);
    };

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col >
                        <Row>
                            <Col md="2">
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 float-end">NDC :</p>
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 font-weight-500">{rowData?.ndc}</p>
                            </Col>
                            <Col md="2">
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 float-end">Total Units Replenished :</p>
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 font-weight-500">{rowData?.orderedUnits}</p>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col md="2">
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 float-end">Drug Name :</p>
                            </Col>
                            <Col md="4">
                                <p className="m-0 f-14 font-weight-500">{rowData?.drugName}</p>
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 float-end">Total Packages Replenished :</p>
                            </Col>
                            <Col md="2">
                                <p className="m-0 f-14 font-weight-500">{rowData?.orderedUnits / rowData?.packageSize}</p>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col md="1" >
                            </Col>
                            <Col><p className="m-0 f-14 "><strong>Note:</strong> Only the most recent 500 records are visible to view. For all records please export.</p></Col>
                        </Row>
                    </Col>
                </Row>
            </CardBody>
            <CardBody className="border-top">
                <ErrorBoundary>
                    <UnitsReplenishedTable
                        data={state.data}
                        loading={state.loading}
                        onExport={handleExport}
                        filters={initialFilters}
                        totalSize={state.records}
                        onPageChange={onPageChange}
                        setLoading={(value) => setState({ loading: value })}
                        refetch={refetch}
                        onSearchColumnFilters={handleSearchColumnFilters}
                        reset={state.reset}
                    />
                </ErrorBoundary>

            </CardBody>
        </Card>
    );
};

export default UnitsReplenished;
